angular.module('aq.filters')
.filter('humanizeDuration', function() {
    return function(input, unit) {
        if (_.isUndefined(input) || _.isNull(input)) {
            return null;
        }
        return moment.duration(input, unit).humanize();
    }
});